import $axios from './api';

export const list = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/consultation/list', payload);
	return data;
};

export const getById = async (consultationId) => {
	const { data } = await $axios.get(`/v1/author/consultation/${ consultationId }`);
	return data;
};

export const create = async ( consultation ) => {
	const { data } = await $axios.post('/v1/author/consultation/create', consultation);
	return data;
};

// TODO переименовать в нормальный payload
export const edit = async ( { consultationId, payload } ) => {
	const { data } = await $axios.post(`/v1/author/consultation/${consultationId}`, payload);
	return data;
};

export const fulfillmentList = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/consultation/fulfillment/list', payload);
	return data;
};

export const fulfillmentStatusUpdate = async ({ fulfillmentId, status }) => {
	const { data } = await $axios.post(`/v1/author/consultation/fulfillment/${fulfillmentId}/status`, { status });
	return data;
};